import type { DetailedPageLoadSlo, Slo } from './types';

export const isDetailedPageLoadSlo = (
	data: DetailedPageLoadSlo | Slo,
): data is DetailedPageLoadSlo => {
	return Boolean((data as DetailedPageLoadSlo).initial);
};
